import { MsalAuthProvider, LoginType } from 'react-aad-msal';

const config = {
    auth: {
        authority: "https://login.microsoftonline.com/common", //Directory (tenant) ID Overview blade of App Registration
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID, //Application (client) ID
        postLogoutRedirectUri: window.location.origin,
        redirectUri: window.location.origin,
        validateAuthority: true,
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true
    }
};

export const authenticationParameters = {
    scopes: [
        //'User.Read',
        'Domain.Read.All',
        'GroupMember.Read.All',
        //'Application.Read.All',
        'Application.ReadWrite.All',
        'User.ReadWrite.All'
    ]
}

export const authenticationParametersGraph = {
    scopes: [
        'openid'
    ]
}

export const options = {
    loginType: LoginType.Popup,
    tokenRefreshUri: window.location.origin,

}

export const loginAuthProviderSignUp = (postLogoutUrl) => {
    if (postLogoutUrl) {
        config.auth.postLogoutRedirectUri = postLogoutUrl;
        return new MsalAuthProvider(config, authenticationParameters, options);
    }

    return new MsalAuthProvider(config, authenticationParameters, options);
}